import { VIEW_BONUS_BALANCE_ENABLED } from 'config';
import { useSelector } from 'react-redux';
import { selectFromOAuth } from 'services/oauth/oauth.selectors';
import { selectSessionInfo } from 'services/session/session.selectors';
import { AppChannel } from 'utils/config.config';
import { useIsAtLeastDesktopBreakpoint } from 'utils/hooks/media-queries';
import NavbarLegacy from './NavbarLegacy.component';
import NavbarWithBonusBalance from './NavbarWithBonusBalance.component';

export default function Navbar() {
  const isNavbarVisible = useNavbarVisibility();

  if (!isNavbarVisible) {
    return null;
  } else if (VIEW_BONUS_BALANCE_ENABLED) {
    return <NavbarWithBonusBalance />;
  } else {
    return <NavbarLegacy />;
  }
}

function useNavbarVisibility() {
  const sessionInfo = useSelector(selectSessionInfo);
  const fromOAuth = useSelector(selectFromOAuth);

  const isAtLeastDesktopBreakpoint = useIsAtLeastDesktopBreakpoint();

  const { channel } = sessionInfo;

  const shouldHideHeader =
    fromOAuth ||
    channel === AppChannel.AppSisalPoker ||
    channel === AppChannel.ClientDesktopSisalPoker ||
    channel === AppChannel.AppCasinoHub ||
    channel === AppChannel.AppMobileScommesse ||
    channel === AppChannel.AppLottery ||
    channel === AppChannel.SkillGamesLtmMobile ||
    (channel === AppChannel.PortaleGiochiNumerici &&
      isAtLeastDesktopBreakpoint);

  return !shouldHideHeader;
}
